/** Centered SVG cursor using one vertical double-arrow glyph at every angle. */
export type LineDragCursor =
  `url("data:image/svg+xml,${string}") 12 12, default`;

/** Rotate the vertical movement arrows perpendicular to the projected segment. */
export const getLineDragCursor = (
  segmentAngleRadians: number,
): LineDragCursor => {
  // Reversing the edge keeps the same bidirectional cursor.
  const angle = ((segmentAngleRadians % Math.PI) + Math.PI) % Math.PI;
  const degrees = (angle * 180) / Math.PI;
  const svg = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g transform="rotate(${degrees} 12 12)">
        <path d="M12 3 L7 8 H10 V16 H7 L12 21 L17 16 H14 V8 H17 Z"
          fill="#111111" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"/>
      </g>
    </svg>`,
  );
  return `url("data:image/svg+xml,${svg}") 12 12, default`;
};

/**
 * Segment direction in radians from two endpoints (screen or metric y-down space).
 */
export const getSegmentAngleRadians = (
  start: readonly [number, number],
  end: readonly [number, number],
): number => Math.atan2(end[1] - start[1], end[0] - start[0]);
